import builder from '../reducerBuilder'
import {
  ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR,
  ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED,
  ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING,

} from '../../constants'

export default builder(
  [ACTION_COGOLAND_RESCHEDULE_SESSION_LOADING],
  [ACTION_COGOLAND_RESCHEDULE_SESSION_LOADED],
  [ACTION_COGOLAND_RESCHEDULE_SESSION_ERROR])



// WEBPACK FOOTER //
// ./src/store/cogoland/selectedCogolandSessionReducer.js